module.exports = __webpack_public_path__ + "static/img/26.21d185e4.png";